var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import uuid from "uuid/v4";
import { useFormContext } from "react-hook-form";
import SurveyService from "../../../../Services/Survey.service";
import SelectSurveyForm from "../../Survey/SelectSurveyForm";
export const WAIT_FOR_SURVEY_RECEIVED_GET_CRITERIA = (formState, { exportNodeId }) => {
    var _a;
    const PERSON_LOADER_DELEGATE_ID = uuid();
    const personLoaderDelegate = {
        id: PERSON_LOADER_DELEGATE_ID,
        type: "PersonLoader",
        criteria: {
            personId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
        },
    };
    return {
        delegates: [personLoaderDelegate],
        criteria: {
            surveyId: {
                value: (_a = formState.survey) === null || _a === void 0 ? void 0 : _a.id,
                isReference: false,
            },
            recipientAffiliationId: {
                isReference: true,
                workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                propertyName: "affiliationId",
            },
        },
    };
};
export const WAIT_FOR_SURVEY_RECEIVED_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const survey = yield SurveyService.get(criteria.surveyId.value);
        return {
            survey,
        };
    }
    catch (_a) {
        throw new Error("This automation uses surveys, which you do not have permission to use. Please see your administrator.");
    }
});
const WaitForSurveyReceivedWorkflowNodeDefinitionForm = ({ name, }) => {
    const useFormProps = useFormContext();
    return _jsx(SelectSurveyForm, Object.assign({ name: name }, useFormProps));
};
export default WaitForSurveyReceivedWorkflowNodeDefinitionForm;
